import React from 'react';
import { Box } from '@mui/material';
import VpsHero from './vps/VpsHero';
import VpsPricing from './vps/VpsPricing';
import VpsProcess from './vps/VpsProcess';
import VpsFeatures from './vps/VpsFeatures';
import VpsComparison from './vps/VpsComparison';
import SampleReport from './vps/SampleReport';
import VpsReviews from './vps/VpsReviews';
import VpsFaq from './vps/VpsFaq';

const HomePage = () => {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box sx={{ background: '#FFFFFF', minHeight: '100vh', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
      <VpsHero onGetStarted={scrollToPricing} />
      <VpsPricing />
      <VpsProcess />
      <VpsFeatures />
      <VpsComparison />
      <SampleReport />
      <VpsReviews />
      <VpsFaq />
    </Box>
  );
};

export default HomePage;
